(ns kyber.events.i18n
  (:require [kyber.events.utils :refer [kyber-event-fx
                                        kyber-event-db]]
            [kyber.events.eql :as eql]))

(defn update-locale
  [db [_ locale-key]]
  (assoc db :i18n/locale-key locale-key))

(kyber-event-db ::update-locale update-locale)

(defn fetch-hardcoded-locale-success [_ [_ resp]]
  (let [locale-key (-> resp :>/curriculum :curriculum/hardcoded-locale)]
    {:dispatch [::update-locale locale-key]}))

(kyber-event-fx
 ::fetch-hardcoded-locale-success
 fetch-hardcoded-locale-success)

(defn fetch-hardcoded-locale-failure [_ _]
  ;; TODO wut do here?
  {})

(kyber-event-fx
 ::fetch-hardcoded-locale-failure
 fetch-hardcoded-locale-failure)

(defn fetch-hardcoded-locale
  [{:keys [db]} [event-name _]]
  (let [curriculum-uuid (-> db :router :route-params :curriculum-uuid)]
    {:db db
     :request
     (eql/no-auth-request
      db
      {:name       event-name
       :params     `[{(:>/curriculum {:curriculum/uuid ~curriculum-uuid})
                      [:curriculum/name
                       :curriculum/hardcoded-locale
                       :curriculum/uuid]}]
       :on-success [::fetch-hardcoded-locale-success]
       :on-failure [::fetch-hardcoded-locale-failure]})}))

(kyber-event-fx ::fetch-hardcoded-locale fetch-hardcoded-locale)
